import React from 'react';
import { m } from 'framer-motion';
export function TaglineBanner() {
  return <section className="bg-navy py-12 sm:py-16" data-id="element-172" data-mp="3uykj2qvbttqa">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-173" data-mp="3uyar4xqq1chy">
        <m.h2 initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="font-heading text-3xl font-extrabold uppercase leading-tight text-white sm:text-4xl" data-id="element-174" data-mp="3gzt83dbrgo6d">
          Abre un tomo. Enseña. Fin.
        </m.h2>
        <m.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mt-5 space-y-2 text-base leading-relaxed text-white/75 sm:text-lg" data-id="element-175" data-mp="3c19nbg8wlifl">
          <p data-id="element-176" data-mp="2ob5t1zhluv19">No más noches preparando clases. No más improviso en la pizarra. No más sensación de que algo falta.</p>
          <p className="font-semibold text-white" data-id="element-177" data-mp="2tbjtowgvn2p9">
            Elige la clase que necesitas, revisa el ejemplo y lleva sus actividades al aula.
          </p>
        </m.div>
      </div>
    </section>;
}